// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-o_fS","galleryItem_borderTopRadius":"c-o_fT","galleryItem__image":"c-o_fU"};